export default {
    configuration: false,
    searchList: {
        searchTxt: [
            {
                name: '预设区域',
                value: 'layerIdList',
                type: 'select',
                multiple: true,
                filterable: true,
                optionNum: '',
                options: [],
                unfold: false,
                span: 5
            },
            {
                name: '排单编号',
                value: 'lineCode',
                type: 'input',
                unfold: true,
                span: 2
            },
            {
                name: '发车单号',
                value: 'trainNum',
                type: 'input',
                unfold: true,
                batch: true,
                span: 2
            },
            {
                name: '服务平台',
                value: 'siteName',
                unfold: true,
                type: 'advance',
                multiple: true,
                multipleTableColumn: {
                    prop: 'escoCompanyNameCn',
                    value: '服务平台名称'
                },
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '名称' },
                    { prop: 'escoCompanyNo', value: '编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', value: '平台名称' },
                    { prop: 'escoCompanyNo', value: '平台编码' }
                ],
                method: 'post',
                prefix: '/api-tms/',
                advanceUrl: '/user/auth/data/site/query',
                cbParams: [
                    'escoCompanyNo#siteCode',
                    'escoCompanyNameCn#siteName'
                ],
                span: 3
            },
            {
                name: '分公司',
                value: 'companyName',
                unfold: false,
                type: 'advance',
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '分公司名称' },
                    { prop: 'escoCompanyNo', value: '分公司编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', value: '分公司名称' },
                    { prop: 'escoCompanyNo', value: '分公司编码' }
                ],
                advanceUrl: '/searchBrand',
                cbParams: [
                    'escoCompanyNameCn#companyName',
                    'escoCompanyNo#companyCode'
                ],
                span: 3
            },
            {
                name: '客户订单号',
                value: 'customerOrderNo',
                type: 'input',
                batch: true,
                unfold: true,
                span: 3
            },
            {
                name: '状态',
                value: 'dispatchStatusList',
                type: 'select',
                multiple: true,
                optionNum: 'ALGORITHM_STATUS',
                options: [],
                unfold: true,
                span: 4
            },
            {
                name: '创建时间',
                value: 'createTime',
                startTime: 'startCreateTime',
                endTime: 'endCreateTime',
                startPlaceholder: '创建开始日期',
                endPlaceholder: '创建结束日期',
                type: 'time',
                timeNum: 3,
                unfold: true,
                span: 5
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        clickModify: true,
        selectBtn: true,
        leftWidth: 80,
        height: '400px',
        leftOperation: true,
        action: [
            {
                type: 'text',
                label: '排车',
                size: 'small',
                event: 'arrange'
            },
            {
                type: 'text',
                label: '编辑',
                size: 'small',
                event: 'edit'
            }
        ],
        columns: [
            {
                label: '服务平台',
                prop: 'siteName',
                width: 140,
                sort: true
            },
            {
                label: '分公司',
                prop: 'companyName',
                width: 140,
                sort: true
            },
            {
                label: '发车单号',
                prop: 'trainNum',
                type: 'button',
                width: 160,
                sort: true
            },
            {
                label: '发车单状态',
                prop: 'dispatchStatus',
                type: 'select',
                optionNum: 'ALGORITHM_STATUS',
                width: 120,
                sort: true
            },
            {
                label: '订单数',
                prop: 'orderNum',
                width: 100,
                sort: true
            },
            {
                label: '方量(m³)',
                prop: 'volume',
                width: 120,
                sort: true
            },
            {
                label: '里程(km)',
                prop: 'mileage',
                width: 120,
                sort: true
            },
            {
                label: '串点数',
                prop: 'pointNum',
                width: 110,
                sort: true
            },
            {
                label: '装载率',
                prop: 'volumeRates',
                width: 130,
                sort: true
            },
            {
                label: '算法预估成本(元)',
                prop: 'cost',
                width: 170,
                sort: true
            },
            {
                label: '发车单成本(元)',
                prop: 'trialCost',
                width: 160,
                sort: true
            },
            {
                label: '推荐车型',
                prop: 'algorithmEquipmentName',
                width: 120,
                sort: true
            },
            {
                label: '采购渠道',
                prop: 'procurementChannel',
                type: 'select',
                optionNum: 'OTP_TMS_PROCUREMENT_CHANNEL',
                width: 120,
                sort: true
            },
            {
                label: '车辆信息',
                prop: 'vehicleCardAndEquipmentName',
                width: 180,
                sort: true
            },
            {
                label: '司机信息',
                prop: 'driverAndDriverContactWay',
                width: 180,
                sort: true
            },
            {
                label: '承运商信息',
                prop: 'carrierName',
                width: 180,
                sort: true
            },
            {
                label: '额载体积(m³)',
                prop: 'truckMaxVolume',
                width: 140,
                sort: true
            },
            {
                label: '是否运力欠缺',
                prop: 'carGap',
                width: 140,
                sort: true
            },
            {
                label: '审核失败原因',
                prop: 'auditFailReason',
                width: 200,
                sort: true
            },
            {
                label: '调整原因',
                prop: 'adjustReason',
                width: 200,
                sort: true
            },
            {
                label: '异常信息',
                prop: 'abnormalRemark',
                width: 250,
                sort: true
            },
            {
                label: '是否无车平台',
                sort: true,
                prop: 'noCarPlatformFlag',
                type: 'select',
                options: [
                    { value: 'Y', label: '是' },
                    { value: 'N', label: '否' }
                ],
                width: 130
            },
            {
                label: '无车平台类型',
                sort: true,
                type: 'select',
                prop: 'noCarCarrierType',
                optionNum: 'NO_CAR_CARRIER_TYPE',
                options: [],
                width: 130
            },
            {
                label: '数量',
                sort: true,
                prop: 'totalQty',
                width: 78
            },
            {
                label: '实发数量',
                sort: true,
                prop: 'loadedEa',
                width: 110
            },
            {
                label: '单量',
                sort: true,
                prop: 'taskCount',
                width: 78
            },
            {
                label: '重量(kg)',
                sort: true,
                prop: 'totalGrossWeight',
                width: 98
            },
            {
                label: '预计到车时间',
                sort: true,
                prop: 'besArriveDate',
                width: 160
            },
            {
                label: '预计逾期时间',
                sort: true,
                prop: 'overDue',
                width: 160
            },
            {
                label: '是否串点计费',
                sort: true,
                prop: 'dmsFlag',
                width: 140,
                type: 'select',
                optionNum: '',
                options: [
                    { value: 1, label: '是' },
                    { value: 0, label: '否' }
                ]
            },
            {
                label: '到车登记时间',
                sort: true,
                prop: 'actualArriveDate',
                width: 150
            },
            {
                label: '到车登记方式',
                sort: true,
                type: 'select',
                prop: 'arriveType',
                optionNum: 'PICK_UP_TYPE',
                options: [],
                width: 130
            },
            {
                label: '始发地',
                sort: true,
                prop: 'senderTownName',
                width: 100
            },
            {
                label: '目的地',
                sort: true,
                prop: 'receiverTownName',
                width: 100
            },
            {
                label: '备注',
                sort: true,
                prop: 'remark',
                width: 120
            },
            {
                label: '标准成本',
                prop: 'standardCost',
                sort: true,
                width: 160
            },
            {
                label: '装载过低异常类型',
                sort: true,
                prop: 'exceptionType',
                optionNum: 'EXCEPTION_TYPE',
                options: [],
                width: 160
            },
            {
                label: '装载过低异常备注',
                sort: true,
                prop: 'exceptionMark',
                width: 160
            },
            {
                label: '排队编码',
                prop: 'queueCode',
                sort: true,
                width: 160
            },
            {
                label: '离园时间',
                prop: 'leaveDate',
                sort: true,
                width: 160
            },
            {
                label: '成本比例(%)',
                prop: 'costRate',
                sort: true,
                width: 160
            },
            {
                label: '车牌号',
                prop: 'vehicleCard',
                sort: true,
                width: 160
            },
            {
                label: '车型',
                prop: 'equipmentName',
                sort: true,
                width: 160
            },
            {
                label: '实发体积',
                prop: 'loadedVolume',
                sort: true,
                width: 160
            },
            {
                label: '装货点数量',
                prop: 'totalArrivalRegistrationSiteNum',
                sort: true,
                width: 160
            },
            {
                label: '发货省',
                prop: 'senderProvinceName',
                sort: true,
                width: 160
            },
            {
                label: '发货市',
                prop: 'senderCityName',
                sort: true,
                width: 160
            },
            {
                label: '发货区',
                prop: 'senderDistrictName',
                sort: true,
                width: 160
            },
            {
                label: '收货省',
                prop: 'receiverProvinceName',
                sort: true,
                width: 160
            },
            {
                label: '收货市',
                prop: 'receiverCityName',
                sort: true,
                width: 160
            },
            {
                label: '收货区',
                prop: 'receiverDistrictName',
                sort: true,
                width: 160
            },
            {
                label: '内径长',
                prop: 'interiorLength',
                sort: true,
                width: 150
            },
            {
                label: '内径宽',
                prop: 'interiorWidth',
                sort: true,
                width: 150
            },
            {
                label: '内径高',
                prop: 'interiorHeight',
                sort: true,
                width: 150
            },
            {
                label: '装货仓库',
                prop: 'whNames',
                sort: true,
                width: 150
            },
            {
                label: '是否使用算法',
                prop: 'newAlgorithmFlag',
                type: 'select',
                options: [
                    { value: 1, label: '是' },
                    { value: 0, label: '否' }
                ],
                width: '160',
                sort: true
            },
            {
                label: '推荐车牌',
                prop: 'equipmentVehicleCard',
                sort: true,
                width: 160
            },
            {
                label: '商品数量',
                prop: 'totalQty',
                sort: true,
                width: 160
            },
            {
                label: '高端服务发车单',
                prop: 'highEndServiceType',
                type: 'select',
                optionNum: '',
                options: [
                    { 'value': 'NONE', 'label': '非高端服务发车单' },
                    { 'value': 'EMERGENCY_ORDER', 'label': '紧急发车单' },
                    { 'value': 'COLMO_ORDER', 'label': 'COLMO专送发车单' }
                ],
                width: 160,
                sort: true
            },
            {
                label: '总里程(算法)',
                prop: 'algoTotalMileage',
                width: 130,
                sort: true
            },
            {
                label: '装货总里程(算法)',
                prop: 'algoLoadingMileage',
                width: 130,
                sort: true
            },
            {
                label: '卸货总里程(算法)',
                prop: 'algoUnloadingMileage',
                width: 130,
                sort: true
            },
            {
                label: '返程里程(算法)',
                prop: 'algoReturnMileage',
                width: 130,
                sort: true
            },
            {
                label: '提货仓数(算法)',
                prop: 'algoLoadingWarehouseNum',
                width: 130,
                sort: true
            },
            {
                label: '卸货串点数(算法)',
                prop: 'algoUnloadingPointNum',
                width: 130,
                sort: true
            },
            {
                label: '司机主运费(算法)',
                prop: 'algoDriverMainCost',
                width: 130,
                sort: true
            },
            {
                label: '是否新计费模式(算法)',
                prop: 'algoBillFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { value: 1, label: '是' },
                    { value: 0, label: '否' }
                ],
                width: 180,
                sort: true
            },
            {
                label: '审核状态',
                prop: 'reviewStatus',
                type: 'select',
                optionNum: '',
                options: [
                    { value: '00', label: '草稿' },
                    { value: '10', label: '审核中' },
                    { value: '40', label: '作废' },
                    { value: '30', label: '驳回' },
                    { value: '20', label: '审核完成' },
                    { value: '100', label: '无需审核' }
                ],
                width: 180,
                sort: true
            },
            {
                label: '低装载率审批详情',
                prop: 'lowLoadingApproval',
                type: 'detail',
                buttonName: '详情',
                emitEvent: 'low-loading-approval',
                width: 130
            },
            {
                label: '站点详情',
                prop: 'stationDetailBtn',
                align: 'center',
                type: 'button',
                sort: true,
                width: 120
            },
            {
                label: '创建人',
                prop: 'createUserName',
                width: 100,
                sort: true
            },
            {
                label: '创建时间',
                prop: 'createTime',
                width: 160,
                sort: true
            }
        ]
    },
    searchTotalTitle: [
        {
            name: '收货市',
            value: 'receiverCityName',
            type: 'advance',
            advanceConfig: [
                { prop: 'ebplNameCn', value: '收货市名称' },
                { prop: 'ebplCode', value: '收货市编码' }
            ],
            tableConfig: [
                { prop: 'ebplNameCn', value: '收货市名称' },
                { prop: 'ebplCode', value: '收货市编码' }
            ],
            cbParams: [
                'ebplCode#receiverCityCode',
                'ebplNameCn#receiverCityName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_CITY',
            advanceCode: 'receiverCityCode'
        },
        {
            name: '收货区',
            value: 'receiverDistrictName',
            type: 'advance',
            multiple: true,
            border: true,
            maxSelect: 5,
            dialogWidth: '800px',
            multipleTableColumn: { prop: 'ebplNameCn', value: '收货区名称' },
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '收货区名称' },
                { 'prop': 'ebplCode', 'value': '收货区编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '收货区名称' },
                { 'prop': 'ebplCode', 'value': '收货区编码' }
            ],
            cbParams: [
                'ebplCode#receiverDistrictCode', 'ebplNameCn#receiverDistrictName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_DISTRICT',
            advanceCascade: 'receiverCityCode#ebplParentPmCode',
            advanceCode: 'receiverDistrictCode'
        },
        {
            name: '收货乡镇',
            value: 'receiverTownName',
            type: 'advance',
            advanceConfig: [
                { prop: 'ebplNameCn', value: '收货乡镇名称' },
                { prop: 'ebplCode', value: '收货乡镇编码' }
            ],
            tableConfig: [
                { prop: 'ebplNameCn', value: '收货乡镇名称' },
                { prop: 'ebplCode', value: '收货乡镇编码' }
            ],
            cbParams: [
                'ebplCode#receiverTownCode',
                'ebplNameCn#receiverTownName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_STREET',
            advanceCode: 'receiverTownCode'
        },
        {
            name: '高端服务发车单',
            value: 'highEndServiceType',
            type: 'select',
            optionNum: '',
            options: [
                { 'value': 'NONE', 'label': '非高端服务发车单' },
                { 'value': 'EMERGENCY_ORDER', 'label': '紧急发车单' },
                { 'value': 'COLMO_ORDER', 'label': 'COLMO专送发车单' }
            ]
        },
        {
            name: '新计费模式(算法)',
            value: 'algoBillFlag',
            type: 'select',
            optionNum: '',
            options: [
                { value: '1', label: '是' },
                { value: '0', label: '否' }
            ]
        }
    ],
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    }
};
